window.humblerSetAtcLoading = window.humblerSetAtcLoading || ((button, isLoading) => {
  if (!button) return;

  const spinner = button.querySelector('.loading-overlay__spinner');

  button.classList.toggle('loading', isLoading);
  button.classList.toggle('humbler-atc-loading', isLoading);
  if (isLoading) {
    button.setAttribute('data-humbler-loading', 'true');
  } else {
    button.removeAttribute('data-humbler-loading');
  }

  if (spinner) {
    spinner.classList.add('hidden');
    spinner.setAttribute('aria-hidden', 'true');
  }
});

if (!window.humblerAtcInteractionFallback) {
  window.humblerAtcInteractionFallback = true;

  const armAtcLoading = (event) => {
    const button = event.target && event.target.closest ? event.target.closest('.product-form__submit') : null;
    if (!button || button.disabled) return;

    window.humblerSetAtcLoading(button, true);
    window.clearTimeout(button._humblerAtcFallbackTimer);
    button._humblerAtcFallbackTimer = window.setTimeout(() => {
      if (button.getAttribute('aria-disabled') !== 'true') {
        window.humblerSetAtcLoading(button, false);
      }
    }, 3500);
  };

  ['pointerdown', 'mousedown', 'touchstart', 'click'].forEach((eventName) => {
    document.addEventListener(eventName, armAtcLoading, true);
  });
}

if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      if (this.querySelector('form')) {
        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      else {
        this.querySelector('[name=id]').disabled = false;
        this.querySelector('button[type=submit]').addEventListener('click', this.onSubmitHandler.bind(this));
      }
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      const loadingStartedAt = performance.now();
      const minimumLoadingTime = this.submitButton.classList.contains('product-form__submit') ? 1200 : 0;

      window.clearTimeout(this.submitButton._humblerAtcFallbackTimer);
      this.submitButton.setAttribute('aria-disabled', true);
      window.humblerSetAtcLoading(this.submitButton, true);

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (!this.form) {
        formData.append('id', this.querySelector('[name=id]').value);
      }
      
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            if (window.customCart) {
              window.customCart.update();
            } else {
              window.location = window.routes.cart_url;
            }
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          const finishLoading = () => {
            window.clearTimeout(this.submitButton._humblerAtcFallbackTimer);
            window.humblerSetAtcLoading(this.submitButton, false);
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          };

          const remainingLoadingTime = Math.max(0, minimumLoadingTime - (performance.now() - loadingStartedAt));
          window.setTimeout(finishLoading, remainingLoadingTime);
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

if (!window.humblerAtcSubmitFallback) {
  window.humblerAtcSubmitFallback = true;

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    const button = form.querySelector('.product-form__submit');
    if (!button) return;

    window.humblerSetAtcLoading(button, true);
  }, true);
}
